"use client";

import "../src/styles/globals.css";
import "../src/styles/tokens.css";
import "@copilotkit/react-ui/styles.css";
import { Navbar } from "./components/Navbar";
import { AuthGuard } from "./components/AuthGuard";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./auth/authConfig";
import AppInsightsProvider from "./appInsights/AppInsightsProvider";
import AuthProviderWrapper from "./auth/AuthProviderWrapper";
import { OnboardDataProvider } from "./context/OnboardDataContext";
import { FeatureFlagProvider } from "./context/FeatureFlagContext";
import MgtProvider from "./auth/MgtProvider";

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="en" suppressHydrationWarning>
      <head>
        <title>Nexus Intelligence</title>
        <meta
          name="description"
          content="A frontend for exploring AI Search datasources"
        />
        {/* Set theme attributes before paint so there is no light/dark flash on load. */}
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(){try{var d=document.documentElement;d.dataset.theme=localStorage.getItem("nexus-theme")||"light";d.dataset.accent=localStorage.getItem("nexus-accent")||"blue";d.dataset.bubble=localStorage.getItem("nexus-bubble")||"tint";}catch(e){var d=document.documentElement;d.dataset.theme="light";d.dataset.accent="blue";d.dataset.bubble="tint";}})();`,
          }}
        />
      </head>
      <body className="font-sans min-h-screen bg-bg text-fg">
        {msalInstance ? (
          <MsalProvider instance={msalInstance}>
            <MgtProvider>
              <AuthProviderWrapper>
                {/*
                  AuthGuard sits directly inside AuthProviderWrapper: it calls
                  useAuth(), so it cannot be hoisted above the provider, but it
                  must stay above the navbar and the data providers. Those
                  providers fetch on `isReady` alone -- true for anonymous
                  visitors too -- so leaving them outside meant token-less calls
                  to /api/feature-flags, /api/config and the onboard prefetch
                  went out before the login redirect navigated away, and the
                  chrome was briefly visible to the public.
                */}
                <AuthGuard>
                  <OnboardDataProvider>
                    <FeatureFlagProvider>
                      <Navbar />
                      <AppInsightsProvider>
                        <main>{children}</main>
                      </AppInsightsProvider>
                    </FeatureFlagProvider>
                  </OnboardDataProvider>
                </AuthGuard>
              </AuthProviderWrapper>
            </MgtProvider>
          </MsalProvider>
        ) : (
          <div className="flex items-center justify-center min-h-screen bg-bg">
            <div className="text-center">
              <h1 className="text-2xl font-bold text-fg mb-4">
                Authentication Error
              </h1>
              <p className="text-fg-secondary">
                MSAL instance could not be initialized. Please check your
                configuration.
              </p>
            </div>
          </div>
        )}
      </body>
    </html>
  );
}
